export const HEALTHCARE_SECTOR_VALUE = 'Hospitals, Healthcare & Clinics';

export interface HealthcareSectorField {
  field_name: string;
  label: string;
  type: string;
  placeholder: string;
  options?: string[];
}

export const HEALTHCARE_SECTOR_FIELDS: HealthcareSectorField[] = [
  {
    field_name: 'clinic_or_hospital',
    label: 'Clinic or Hospital',
    type: 'select',
    placeholder: 'Select Clinic or Hospital',
    options: ['Clinic', 'Hospital'],
  },
  {
    field_name: 'clinic_or_hospital_size',
    label: 'Clinic or Hospital size',
    type: 'select',
    placeholder: 'Select Clinic or Hospital size',
    options: ['Small', 'Medium', 'Large'],
  },
  {
    field_name: 'number_of_patients',
    label: 'Number of patient',
    type: 'number',
    placeholder: 'Number of patient',
  },
  {
    field_name: 'number_of_doctors',
    label: 'Number of doctors',
    type: 'number',
    placeholder: 'Number of doctors',
  },
];

function normKey(value: string): string {
  return (value || '').toLowerCase().replace(/[\s_-]+/g, '');
}

export function isLeadSectorField(field: { field_name?: string; label?: string } | null | undefined): boolean {
  if (!field) {
    return false;
  }
  return normKey(field.field_name || '') === 'sector' || normKey(field.label || '') === 'sector';
}

export function getSectorFieldName(allLeadFields: any[] = []): string | null {
  for (const item of allLeadFields || []) {
    if (isLeadSectorField(item)) {
      return item.field_name;
    }
  }
  return null;
}

export function isHealthcareSectorValue(value: unknown): boolean {
  return String(value ?? '').trim() === HEALTHCARE_SECTOR_VALUE;
}

export function clearHealthcareSectorFieldValues(fields: Record<string, unknown> | null | undefined): void {
  if (!fields) {
    return;
  }
  for (const item of HEALTHCARE_SECTOR_FIELDS) {
    fields[item.field_name] = '';
  }
}
